module.exports = __webpack_public_path__ + "img/img-header-mobile.29173ec.webp";